<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <ng-content select="[content]"></ng-content>
</ft-modal-editor-wrapper>
